import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { ProjectProvider, IntentsProvider, LoadingProvider, TranslationProvider, ValidProvider, msalConfig } from './lib'
import 'material-icons/iconfont/material-icons.css';
import './styles/main.scss'
import './styles/responsive.css'
import { CookiesProvider } from 'react-cookie';
import 'animate.css';

import { validateFileHeader } from './lib/fileValidator';

const originalAppend = FormData.prototype.append;

FormData.prototype.append = function (name, value, filename) {
  if (value instanceof File) {
    validateFileHeader(value)
      .then(() => {
        console.log(`%c[Security Check] %cFile "${value.name}" validated correctly.`, 
                    "color: #4CAF50; font-weight: bold;", "color: default;");
      })
      .catch((err) => {
        console.error(`%c[Security Block] %cAttempted file: ${value.name}. Reason: ${err.message}`, 
                      "color: #F44336; font-weight: bold;", "color: default;");
        
        alert(err.message);
        // Opcional: window.location.reload();
      });
  }
  return originalAppend.apply(this, arguments);
};

const msalInstance = new PublicClientApplication(msalConfig)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <CookiesProvider>
        <TranslationProvider>
          <ProjectProvider>
            <ValidProvider>
              <LoadingProvider>
                <IntentsProvider>
                  <App />
                </IntentsProvider>
              </LoadingProvider>
            </ValidProvider>
          </ProjectProvider>
        </TranslationProvider>
      </CookiesProvider>
    </MsalProvider>
  </React.StrictMode> 
)
